import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { App } from '@capacitor/app';
import { environment } from '../../environments/environment';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AppInfoService {
    private version: string = environment.version || '0.0';
    private platformName: string = 'web';

    private isDeprecatedSubject = new BehaviorSubject<boolean>(false);
    public isDeprecated$ = this.isDeprecatedSubject.asObservable();

    private isObsoleteSubject = new BehaviorSubject<boolean>(false);
    public isObsolete$ = this.isObsoleteSubject.asObservable();

    private obsoleteMessageSubject = new BehaviorSubject<string>('');
    public obsoleteMessage$ = this.obsoleteMessageSubject.asObservable();

    private storeUrlSubject = new BehaviorSubject<string>('');
    public storeUrl$ = this.storeUrlSubject.asObservable();

    constructor(private plt: Platform) {
        this.detectPlatform();
        this.initAppInfo();
    }

    private detectPlatform() {
        if (this.plt.is('ios')) {
            this.platformName = 'ios';
        } else if (this.plt.is('android')) {
            this.platformName = 'android';
        } else {
            this.platformName = 'web';
        }
    }

    private async initAppInfo() {
        if (this.plt.is('hybrid')) {
            try {
                const info = await App.getInfo();
                this.version = info.version;
            } catch (e) {
                console.error('Error getting app info', e);
                this.version = (environment as any).version || '0.0';
            }
        } else {
            this.version = (environment as any).version || '0.0';
        }
    }

    getVersion(): string {
        return this.version;
    }

    getPlatform(): string {
        return this.platformName;
    }

    setVersionDeprecated() {
        if (!this.isDeprecatedSubject.value) {
            this.isDeprecatedSubject.next(true);
        }
    }

    setVersionObsolete(message: string = '', storeUrl: string = '') {
        if (!this.isObsoleteSubject.value) {
            this.isObsoleteSubject.next(true);
            if (message) {
                this.obsoleteMessageSubject.next(message);
            }
            if (storeUrl) {
                this.storeUrlSubject.next(storeUrl);
            }
        }
    }
}
